import {Component} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {MainMenu} from '../components/main-menu/main-menu';
import {Header} from '../components/header/header';

@Component({
  selector: 'elcia-layout',
  imports: [RouterOutlet, MainMenu, Header],
  templateUrl: './home.html',
})
export class Home {

}
